import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast_position } from "../../Settings/Authorization";
import { toast } from "react-toastify";
import { env } from "../../../../env";
import axiosInstance from "../../../globalInspector/axiosInstance";
import CommonToast from "../../../../components/_utils/CommonToast";
import ICONS from "../../../../assets/Icons";

const baseUrl = env.REACT_APP_BASE_URL;

export const ownerViewAllAcc = createAsyncThunk(
  "ownerViewAllAcc",
  async (values, { rejectWithValue }) => {
    const {
      page_no,
      page_size,
      active_status,
      connected_banking,
      search_string,
      type_of_account,
      bank_account_no,
      ifsc,
      pan,
      bank_name,
      sort_by_balance,
    } = values; // Destructure page_no and page_size from values
    try {
      const response = await axiosInstance.get(`${baseUrl}/accounts/owner`, {
        headers: {
          "Content-Type": "application/json",
          "X-Api-Key": sessionStorage.getItem("q2p_token"),
        },
        params: {
          "page_no": page_no,
          "page_size": page_size,
          "active_status": active_status,
          "connected_banking": connected_banking,
          "search_string": search_string,
          "type_of_account": type_of_account,
          "bank_account_no": bank_account_no,
          "ifsc": ifsc,
          "pan": pan,
          "bank_name": bank_name,
          "sort_by_balance[balance]": sort_by_balance
            ? sort_by_balance === "Low to high"
              ? "ascending"
              : "descending"
            : undefined,
        },
      });
      return response.data;
    } catch (error) {
      toast.error(error.response.data.error, toast_position);
      return rejectWithValue(error);
    }
  },
);

// export const uploadFile = createAsyncThunk(
//   "uploadFile",
//   async (file, { rejectWithValue }) => {

//     try {

//       const formData = new FormData();
//       formData.append("file", file);

//       const response = await axiosInstance.post(`${baseUrl}/files/upload`, formData, {
//         headers: {
//           "X-Api-Key": sessionStorage.getItem("q2p_token"),

//         },
//       });

//       return response.data;

//     } catch (error) {
//       return rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );

export const uploadFile = createAsyncThunk(
  "uploadFile",
  async (values, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("file", values?.file);

      const response = await axiosInstance.post(
        `${baseUrl}/files/upload`,
        formData,
        {
          headers: {
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
            "Content-Type": "multipart/form-data",
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// export const uploadStatement = createAsyncThunk(
//   "uploadStatement",
//   async (values, { rejectWithValue }) => {

//     const { file, bank_name, account_no } = values;

//     try {
//       // Create FormData
//       const formData = new FormData();
//       formData.append("file", file);
//       formData.append("bank_name", bank_name);
//       formData.append("account_no", account_no);

//       // Send POST request
//       const response = await axiosInstance.post(`${baseUrl}/statements/upload`, formData, {
//         headers: {
//           "X-Api-Key": sessionStorage.getItem("q2p_token"),

//         },
//       });

//       return response.data;

//     } catch (error) {
//       return rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );

export const uploadStatement = createAsyncThunk(
  "uploadStatement",
  async (statementPayload, { rejectWithValue }) => {
    try {
      const payload = {
        bank_name: statementPayload?.bank_name,
        account_no: statementPayload?.account_no,
        uploaded_file_data: {
          id: statementPayload?.uploaded_file_data?.id,
          storage: "cache",
          metadata: {
            filename: statementPayload?.uploaded_file_data?.metadata?.filename,
            size: statementPayload?.uploaded_file_data?.metadata?.size,
            mime_type:
              statementPayload?.uploaded_file_data?.metadata?.mime_type,
          },
        },
      };

      const sucessData = {
        bank_name: statementPayload?.bank_name,
        account_no: statementPayload?.account_no,
        iFSC_Code: statementPayload?.iFSC_Code,
        Bank_logo: statementPayload?.Bank_logo,
        uploaded_file_data: {
          id: statementPayload?.uploaded_file_data?.id,
          storage: "cache",
          metadata: {
            filename: statementPayload?.uploaded_file_data?.metadata?.filename,
            size: statementPayload?.uploaded_file_data?.metadata?.size,
            mime_type:
              statementPayload?.uploaded_file_data?.metadata?.mime_type,
          },
        },
      };

      sessionStorage.setItem("uploadStatementData", JSON.stringify(sucessData));
      const response = await axiosInstance.post(
        `${baseUrl}/statements/upload`,
        payload,
        {
          headers: {
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
            "Content-Type": "application/json",
          },
        },
      );

      return response.data;
    } catch (error) {
      // console.error("Error uploading statement:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
// export const uploadTransactionStatement = createAsyncThunk(
//   "uploadTransactionStatement",
//   async (statementPayload, additional_data, { rejectWithValue }) => {
//     try {
//       // const add_data = {
//       //   data: [
//       //     {
//       //       name: ,
//       //       position: 1,
//       //       data_type: "string",
//       //       mandatory: "N",
//       //     },
//       //   ],
//       // };
//       const payload = {
//         uploaded_file_data: {
//           id: statementPayload?.uploaded_file_data?.id,
//           storage: "cache",
//           metadata: {
//             filename: statementPayload?.uploaded_file_data?.metadata?.filename,
//             size: statementPayload?.uploaded_file_data?.metadata?.size,
//             mime_type:
//               statementPayload?.uploaded_file_data?.metadata?.mime_type,
//           },
//         },
//       };

//       sessionStorage.setItem("uploadStatementData", JSON.stringify(payload));
//       const response = await axiosInstance.post(
//         `${baseUrl}/statements/upload`,
//         payload,
//         {
//           headers: {
//             "X-Api-Key": sessionStorage.getItem("q2p_token"),
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       return response.data;
//     } catch (error) {
//       // console.error("Error uploading statement:", error);
//       return rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );

export const uploadTransactionStatement = createAsyncThunk(
  "uploadTransactionStatement",
  async ({ statementPayload }, { rejectWithValue }) => {
    try {
      const payload = {
        uploaded_file_data: {
          id: statementPayload?.uploaded_file_data?.id,
          storage: "cache",
          metadata: {
            filename: statementPayload?.uploaded_file_data?.metadata?.filename,
            size: statementPayload?.uploaded_file_data?.metadata?.size,
            mime_type:
              statementPayload?.uploaded_file_data?.metadata?.mime_type,
          },
        },

        category: statementPayload?.category,
      };
      sessionStorage.setItem("uploadTxnStatementData", JSON.stringify(payload));

      const response = await axiosInstance.post(
        `${baseUrl}/transactions/upload`,
        payload,
        {
          headers: {
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
            "Content-Type": "application/json",
          },
        },
      );

      return response.data;
    } catch (error) {
      sessionStorage.setItem("data", JSON.stringify(error));
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
export const downloadSampleFile = createAsyncThunk(
  "downloadSampleFile",
  async ({ category }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `${baseUrl}/transactions/sample_file.xlsx`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          params: {
            category: category,
          },
          responseType: "blob",
        },
      );
      let blob = response.data;

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;

      link.setAttribute("download", `${category}_sample_file.xlsx`);

      document.body.appendChild(link);

      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      CommonToast({
        text: "Sample file downloaded successfully.",
        icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      return true;
    } catch (error) {
      let errorMessage = "Something went wrong";

      try {
        const errorBlob = await error.response.data;
        const text = await errorBlob.text();
        const parsed = JSON.parse(text);

        errorMessage =
          parsed?.error?.base ||
          parsed?.error?.message ||
          parsed?.message ||
          error.message ||
          "Something went wrong";
      } catch (err) {
        errorMessage = error.message || "Something went wrong";
      }
      CommonToast({
        text: errorMessage,
        icon: ICONS?.ERROR_WITH_WHITE_OUTLINED_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      return rejectWithValue(errorMessage);
    }
  },
);

export const ownerListViewAllAcc = createAsyncThunk(
  "ownerListViewAllAcc",
  async (values, { rejectWithValue }) => {
    const {
      page_no,
      page_size,
      search_string,
      connected_banking,
      type_of_account,
      bank_account_no,
      ifsc,
      pan,
      bank_name,
      sort_by_balance,
      tag,
      favourite,
      labels,
    } = values;
    try {
      const response = await axiosInstance.get(`${baseUrl}/accounts/owner`, {
        headers: {
          "Content-Type": "application/json",
          "X-Api-Key": sessionStorage.getItem("q2p_token"),
        },
        params: {
          "page_no": page_no,
          "page_size": page_size,
          "search_string": search_string,
          "connected_banking": connected_banking,
          "type_of_account": type_of_account,
          "bank_account_no": bank_account_no,
          "ifsc": ifsc,
          "pan": pan,
          "tag": tag,
          "bank_name": bank_name,
          "sort_by_balance[balance]": sort_by_balance
            ? sort_by_balance === "Low to high"
              ? "ascending"
              : "descending"
            : undefined,
          "favourite": favourite,
          "labels": labels,
        },
      });
      return response.data;
    } catch (error) {
      toast.error(error.response.data.error, toast_position);
      return rejectWithValue(error);
    }
  },
);

export const ownerDashboard = createAsyncThunk(
  "ownerDashboard",
  async ({ page, page_size }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/accounts/owner`, {
        headers: {
          "Content-Type": "application/json",
          "X-Api-Key": sessionStorage.getItem("q2p_token"),
        },
        params: {
          page_no: page,
          page_size: page_size,
        },
      });
      return response.data;
    } catch (error) {
      toast.error(error, toast_position);
      return rejectWithValue(error);
    }
  },
);

export const ownerAccDetail = createAsyncThunk(
  "ownerAccDetail",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `${baseUrl}/accounts/owner/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response.data;
    } catch (error) {
      toast.error(error.response.data.errors.base[0], toast_position);
      return rejectWithValue(error);
    }
  },
);

export const ownerAccAddFavourite = createAsyncThunk(
  "ownerAccAddFavourite",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/owner/${id}/add_favourite`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response.data;
    } catch (error) {
      toast.error(error.response.data.errors[0], toast_position);
      return rejectWithValue(error);
    }
  },
);

export const ownerAccRemoveFavourite = createAsyncThunk(
  "ownerAccRemoveFavourite",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/owner/${id}/remove_favourite`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response.data;
    } catch (error) {
      toast.error(error.response.data.errors[0], toast_position);
      return rejectWithValue(error);
    }
  },
);

export const updateOwnerDetails = createAsyncThunk(
  "updateOwnerDetails",
  async (
    { id, type_of_account, od_limit, min_limit, max_limit },
    { rejectWithValue },
  ) => {
    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/owner/set_limit/${id}`,
        {
          type_of_account: type_of_account,
          od_limit: od_limit,
          min_limit: min_limit,
          max_limit: max_limit,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response.data;
    } catch (error) {
      if (error?.response?.data?.errors?.base?.[0]) {
        toast.dismiss();
        CommonToast({
          text: error.response.data.errors.base[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
          btnProps: {
            enabledBgColor: "var(--primary-bg)",
            enabledTextColor: "var(--text-primary)",
            btnText: "",
            handleFunction: () => {},
            icon: "",
            btnType: "button",
            isDisabled: false,
            hoverOption: "white",
          },
        });
      }
      return rejectWithValue(error?.response?.data);
    }
  },
);

export const getOwnerAccStatement = createAsyncThunk(
  "accounts/getOwnerAccStatement",
  async (
    {
      id,
      start_date,
      end_date,
      page_no,
      credit_debit,
      start_amount,
      end_amount,
      page_size,
    },
    { rejectWithValue },
  ) => {
    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/owner/${id}/display_statement`,
        {
          start_date: start_date,
          end_date: end_date,
          page_no: page_no,
          credit_debit: credit_debit,
          start_amount: start_amount,
          end_amount: end_amount,
          page_size: page_size,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response.data;
    } catch (error) {
      toast.error(error.response.data.errors.base[0], toast_position);
      return rejectWithValue(error);
    }
  },
);

export const getAllOwnerAccStatement = createAsyncThunk(
  "accounts/getAllOwnerAccStatement",
  async (
    {
      id,
      start_date,
      end_date,
      page_no,
      credit_debit,
      start_amount,
      end_amount,
      page_size,
      bank_name,
      entry_source,
    },
    { rejectWithValue },
  ) => {
    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/owner/consolidated_statement`,
        {
          start_date: start_date,
          end_date: end_date,
          page_no: page_no,
          credit_debit: credit_debit,
          start_amount: start_amount,
          end_amount: end_amount,
          page_size: page_size,
          owner_account_id: id,
          bank_name,
          entry_source,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response.data;
    } catch (error) {
      if (error?.response?.data?.errors?.user_unauthorized)
        CommonToast({
          text: error?.response?.data?.errors?.user_unauthorized,
          icon: "https://q2pay.in/new_assets/common/detail_page/info.svg",
          variant: "var(--error)",
          buttonNeeded: false,
        });
      if (error?.response?.data?.errors?.base[0])
        CommonToast({
          text: error?.response?.data?.errors?.base[0],
          icon: "https://q2pay.in/new_assets/common/detail_page/info.svg",
          variant: "var(--error)",
          buttonNeeded: false,
        });
      return rejectWithValue(error);
    }
  },
);

export const addStatementDescription = createAsyncThunk(
  "accounts/addStatementDescription",
  async ({ id, statement_entry_id, description }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/owner/statement_entry/add_description`,
        {
          id,
          statement_entry_id,
          description,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response.data;
    } catch (error) {
      if (error?.response?.data?.errors?.user_unauthorized)
        CommonToast({
          text: error?.response?.data?.errors?.user_unauthorized,
          icon: "https://q2pay.in/new_assets/common/detail_page/info.svg",
          variant: "var(--error)",
          buttonNeeded: false,
        });
      if (error?.response?.data?.errors?.base?.[0])
        CommonToast({
          text: error?.response?.data?.errors?.base?.[0],
          icon: "https://q2pay.in/new_assets/common/detail_page/info.svg",
          variant: "var(--error)",
          buttonNeeded: false,
        });
      if (error?.response?.data?.errors)
        CommonToast({
          text: error?.response?.data?.errors,
          icon: "https://q2pay.in/new_assets/common/detail_page/info.svg",
          variant: "var(--error)",
          buttonNeeded: false,
        });

      return rejectWithValue(error);
    }
  },
);

export const addItemizedStatementDescription = createAsyncThunk(
  "accounts/addItemizedStatementDescription",
  async ({ id, statement_entry_id, description }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/owner/itemised_statement_entry/add_description`,
        {
          id,
          statement_entry_id,
          description,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response.data;
    } catch (error) {
      if (error?.response?.data?.errors?.user_unauthorized)
        CommonToast({
          text: error?.response?.data?.errors?.user_unauthorized,
          icon: "https://q2pay.in/new_assets/common/detail_page/info.svg",
          variant: "var(--error)",
          buttonNeeded: false,
        });
      if (error?.response?.data?.errors?.base?.[0])
        CommonToast({
          text: error?.response?.data?.errors?.base?.[0],
          icon: "https://q2pay.in/new_assets/common/detail_page/info.svg",
          variant: "var(--error)",
          buttonNeeded: false,
        });
      if (error?.response?.data?.errors)
        CommonToast({
          text: error?.response?.data?.errors,
          icon: "https://q2pay.in/new_assets/common/detail_page/info.svg",
          variant: "var(--error)",
          buttonNeeded: false,
        });

      return rejectWithValue(error);
    }
  },
);

export const downloadOwnerStatement = createAsyncThunk(
  "downloadOwnerStatement",
  async ({
    id,
    formatType,
    start_date,
    end_date,
    credit_debit,
    start_amount,
    end_amount,
  }) => {
    const data = {
      start_date,
      end_date,
      credit_debit,
      start_amount,
      end_amount,
    };

    try {
      const response = await fetch(
        `${baseUrl}/accounts/owner/${id}/display_statement_download.${formatType}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          body: JSON.stringify(data),
        },
      );

      if (!response.ok) {
        throw new Error(`Error: ${response.status} ${response.statusText}`);
      }

      // Simple Explanation of the Flow:
      // Get the file as a blob (a raw file).
      // Create a download URL so the browser can access the file.
      // Create a hidden download link.
      // Set the file name (like statement.pdf).
      // Click the link automatically to trigger the download.
      // Clean up by removing the temporary link and URL.

      let blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;

      link.setAttribute("download", `statement.${formatType}`);

      document.body.appendChild(link);

      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      return true;
    } catch (error) {
      throw error;
    }
  },
);

export const downloadAllOwnerStatement = createAsyncThunk(
  "downloadAllOwnerStatement",
  async (
    {
      id,
      formatType,
      start_date,
      end_date,
      credit_debit,
      start_amount,
      end_amount,
      bank_name,
      filter_columns,
      entry_source,
    },
    { rejectWithValue },
  ) => {
    const data = {
      owner_account_id: id,
      start_date,
      end_date,
      credit_debit,
      start_amount,
      end_amount,
      bank_name,
      filter_columns,
      entry_source,
    };

    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/owner/consolidated_statement_download.${formatType}`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          responseType: "blob",
        },
      );

      let blob = response.data;
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `statement.${formatType}`);

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      return true;
    } catch (error) {
      let errorMessage = "Something went wrong";

      try {
        const errorBlob = await error.response.data;
        const text = await errorBlob.text();
        const parsed = JSON.parse(text);
        errorMessage =
          parsed?.errors?.errors ||
          parsed?.errors ||
          parsed?.errors?.base?.[0] ||
          parsed?.errors?.token_expired ||
          parsed?.errors?.message ||
          parsed?.message ||
          error.message ||
          "Something went wrong";
      } catch (err) {
        errorMessage = error.message || "Something went wrong";
      }
      CommonToast({
        text: errorMessage,
        icon: "https://q2pay.in/new_assets/common/detail_page/info.svg",
        variant: "var(--error)",
        buttonNeeded: false,
      });

      return rejectWithValue(error.message);
    }
  },
);

export const getAllOwnerItemisizedReport = createAsyncThunk(
  "accounts/getAllOwnerItemisizedReport",
  async (
    {
      id,
      start_date,
      end_date,
      page_no,
      credit_debit,
      start_amount,
      end_amount,
      page_size,
    },
    { rejectWithValue },
  ) => {
    try {
      const response = await axiosInstance.get(
        `${baseUrl}/accounts/owner/consolidated_itemised_statement`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          params: {
            from_date: start_date,
            to_date: end_date,
            page_no: page_no,
            credit_debit: credit_debit,
            min_amount: start_amount,
            max_amount: end_amount,
            page_size: page_size,
            owner_account_id: id,
          },
        },
      );
      return response.data;
    } catch (error) {
      CommonToast({
        text: error.response.data.errors.base[0],
        icon: "https://q2pay.in/new_assets/common/detail_page/info.svg",
        variant: "var(--error)",
        buttonNeeded: false,
      });
      CommonToast({
        text: error?.response?.data?.errors?.user_unauthorized[0],
        icon: "https://q2pay.in/new_assets/common/detail_page/info.svg",
        variant: "var(--error)",
        buttonNeeded: false,
      });

      return rejectWithValue(error);
    }
  },
);

export const downloadAllItemisizedReport = createAsyncThunk(
  "downloadAllItemisizedReport",
  async (
    {
      id,
      formatType,
      start_date,
      end_date,
      credit_debit,
      start_amount,
      end_amount,
      filter_columns,
    },
    { rejectWithValue },
  ) => {
    const data = {
      owner_account_id: id,
      from_date: start_date,
      to_date: end_date,
      credit_debit,
      min_amount: start_amount,
      max_amount: end_amount,
      filter_columns,
    };

    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/owner/consolidated_itemised_statement_download.${formatType}`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          responseType: "blob",
        },
      );

      let blob = response.data;

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;

      link.setAttribute("download", `livestatement.${formatType}`);

      document.body.appendChild(link);

      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      return true;
    } catch (error) {
      let errorMessage = "Something went wrong";

      try {
        const errorBlob = await error.response.data;
        const text = await errorBlob.text();
        const parsed = JSON.parse(text);
        errorMessage =
          parsed?.errors?.base[0] ||
          parsed?.errors?.token_expired ||
          parsed?.errors?.message ||
          parsed?.message ||
          error.message ||
          "Something went wrong";
      } catch (err) {
        errorMessage = error.message || "Something went wrong";
      }
      CommonToast({
        text: errorMessage,
        icon: "https://q2pay.in/new_assets/common/detail_page/info.svg",
        variant: "var(--error)",
        buttonNeeded: false,
      });
      return rejectWithValue(errorMessage);
    }
  },
);

export const addOwnerAccTags = createAsyncThunk(
  "accounts/addOwnerAccTags",
  async ({ owner_id, tags }, { rejectWithValue }) => {
    const data = {
      owner_id: owner_id,
      tags: tags,
    };

    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/owner/add_tag`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response.data;
    } catch (error) {
      toast.error(error.response.data.errors?.base[0], toast_position);
      toast.error(
        error.response.data.errors?.user_unauthorized[0],
        toast_position,
      );
      return rejectWithValue(error);
    }
  },
);
export const removeOwnerAccTags = createAsyncThunk(
  "accounts/removeOwnerAccTags",
  async ({ owner_id, tags }, { rejectWithValue }) => {
    const data = {
      owner_id: owner_id,
      tags: tags,
    };
    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/owner/remove_tag`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response.data;
    } catch (error) {
      if (error.response.data.errors?.base) {
        toast.error(error.response.data.errors?.base[0], toast_position);
      } else {
        toast.error(
          error.response.data.errors?.user_unauthorized[0],
          toast_position,
        );
      }

      return rejectWithValue(error);
    }
  },
);

export const getOwnerAccBalance = createAsyncThunk(
  "accounts/getOwnerAccBalance",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/owner/${id}/balance`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getCreateTransactionBalance = createAsyncThunk(
  "accounts/getCreateTransactionBalance",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/owner/${id}/balance`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response.data;
    } catch (error) {
      let errormsg =
        error.response?.data?.errors?.base[0] ||
        error.response?.data?.message ||
        error.response?.data?.error ||
        "An unexpected error occurred.";

      return rejectWithValue(errormsg);
    }
  },
);

export const refreshAllOwnerAccBalance = createAsyncThunk(
  "refreshAllOwnerAccBalance",
  async (id, { rejectWithValue }) => {
    try {
      const response = await fetch(`${baseUrl}/accounts/owner/${id}/balance`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "X-Api-Key": sessionStorage.getItem("q2p_token"),
        },
      });
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();

      return data;
    } catch (error) {
      toast.error(error);
      return rejectWithValue(error);
    }
  },
);
export const getOwnerAccountIFSCDetails = createAsyncThunk(
  "getOwnerAccountIFSCDetails",
  async (values, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `${baseUrl}/verification/ifsc/` + values?.search_string,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      if (response.data?.errors) {
        toast.error(response.data.errors.base[0], toast_position);
      }

      return response.data;
    } catch (error) {
      // CommonToast({
      //   text:
      //     error?.response?.data?.errors?.base?.[0] || "Something went wrong",
      //   icon: ICONS?.ERROR_WHITE_CIRCLE,
      //   variant: "var(--error)",
      //   btnProps: {
      //     isDisabled: false,
      //     enabledTextColor: "var(--text-primary)",
      //     enabledBgColor: "var(--primary-bg)",
      //   },
      // });
      return rejectWithValue(error);
    }
  },
);

export const getOwnerAccStatitics = createAsyncThunk(
  "getOwnerAccStatitics",
  async (
    {
      id,
      start_date,
      end_date,
      // interest_rate
    },
    { rejectWithValue },
  ) => {
    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/owner/${id}/historic_balance_report_income`,
        {
          start_date: start_date,
          end_date: end_date,
          investment_percent: 100,
          // interest_rate: interest_rate,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getOwnerAccWeekStatitics = createAsyncThunk(
  "getOwnerAccWeekStatitics",
  async (
    {
      id,
      start_date,
      end_date,
      // interest_rate
    },
    { rejectWithValue },
  ) => {
    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/owner/${id}/historic_balance_report_income`,
        {
          start_date: start_date,
          end_date: end_date,
          investment_percent: 100,
          // interest_rate: interest_rate,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const addNewLabelOwner = createAsyncThunk(
  "addNewLabelOwner",
  async ({ record_ids, labels }, { rejectWithValue }) => {
    const data = {
      record_ids: record_ids,
      labels: labels,
    };

    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/owner/add_label`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      const existingLabels = JSON?.parse(
        sessionStorage?.getItem("AvailableLabelsOwner") || [],
      );

      const updatedLabels = Array?.from(
        new Set([...existingLabels, ...labels]),
      );

      const payload = JSON?.stringify(updatedLabels);
      sessionStorage?.setItem("AvailableLabelsOwner", payload);

      return response?.data;
    } catch (error) {
      const apiErrors = error?.response?.data?.errors;

      const message =
        apiErrors?.base?.[0] ||
        apiErrors?.user_unauthorized?.[0] ||
        "Something went wrong";

      toast.dismiss();
      CommonToast({
        text: message,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });

      return rejectWithValue(message);
    }
  },
);

export const removeNewLabelOwner = createAsyncThunk(
  "removeNewLabelOwner",
  async ({ record_ids, labels }, { rejectWithValue }) => {
    const data = {
      record_ids: record_ids,
      labels: labels,
    };
    try {
      const response = await axiosInstance.put(
        `${baseUrl}/accounts/owner/remove_label`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response?.data;
    } catch (error) {
      const apiErrors = error?.response?.data?.errors;

      const message =
        apiErrors?.base?.[0] ||
        apiErrors?.user_unauthorized?.[0] ||
        "Something went wrong";

      toast.dismiss();
      CommonToast({
        text: message,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });

      return rejectWithValue(message);
    }
  },
);

const ownerAllVerification = createSlice({
  name: "ownerAllVerification",
  initialState: {
    toggle: false,
    storedPage: 1,
    ownerAccountAvailabletags: [],
    ownerAccountAvailableLabels: [],

    addOwnerAccTagsLoading: true,
    addOwnerAccTagsData: [],
    addOwnerAccTagsError: false,

    addOwnerLabelsLoading: true,
    addOwnerLabelsData: [],
    addOwnerLabelsError: false,

    removeOwnerLabelsLoading: true,
    removeOwnerLabelsData: [],
    removeOwnerLabelsError: false,

    ownerAccAddFavouriteError: null,
    ownerAccAddFavouriteDetail: null,
    ownerAccAddFavouriteLoading: false,

    ownerAccRemoveFavouriteError: null,
    ownerAccRemoveFavouriteDetail: null,
    ownerAccRemoveFavouriteLoading: false,

    removeOwnerAccTagsLoading: true,
    removeOwnerAccTagsData: [],
    removeOwnerAccTagsError: false,

    ownerViewAllAccData: null,
    ownerViewAllAccLoading: null,
    ownerViewAllAccError: false,
    ownerViewAllAccErrorData: null,

    ownerViewAllListAccData: null,
    ownerViewAllListAccLoading: null,
    ownerViewAllListAccError: false,
    ownerViewAllListAccErrorData: null,

    ownerDashboardAccData: null,
    ownerDashboardAccLoading: null,
    ownerDashboardAccError: null,

    uploadStatementLoading: null,
    uploadStatementData: null,
    uploadStatementError: null,

    uploadTransactionStatementLoading: null,
    uploadTransactionStatementData: null,
    uploadTransactionStatementError: null,

    ownerAccDetailData: null,
    ownerAccDetailLoading: null,
    ownerAccDetailError: null,

    ownerAccBalanceLoading: false,
    ownerAccBalanceError: null,
    ownerAllAccBalanceLoading: false,
    ownerAllAccBalanceError: false,
    ownerAccBalanceData: null,
    showSuccessToast: false,

    ownerAccStatementLoading: true,
    ownerAccStatementError: false,
    ownerAccStatementData: null,

    ownerAllAccStatementLoading: false,
    ownerAllAccStatementError: false,
    ownerAllAccStatementData: null,

    ownerAllAccAddDescriptionLoading: false,
    ownerAllAccAddDescriptionError: false,
    ownerAllAccAddDescriptionData: null,

    ownerItemizedAddDescriptionLoading: false,
    ownerItemizedAddDescriptionError: false,
    ownerItemizedAddDescriptionData: null,

    ownerAllAccItemisedLoading: false,
    ownerAllAccItemisedError: false,
    ownerAllAccItemisedData: null,

    createTransactionBankRefreshLoading: null,
    createTransactionBankRefreshData: null,
    createTransactionBankRefreshError: null,

    ownerAccIfscLoading: false,
    ownerAccIfscError: false,
    ownerAccIfscData: null,

    getOwnerAccStatiticsLoading: false,
    getOwnerAccStatiticsError: false,
    getOwnerAccStatiticsData: null,

    getOwnerAccWeekStatiticsLoading: false,
    getOwnerAccWeekStatiticsError: false,
    getOwnerAccWeekStatiticsData: null,

    width: window.innerWidth,
    tokenExpire: false,
  },
  reducers: {
    setWindowWidth: (state) => {
      state.width = window.innerWidth;
    },
    setshowsuccestoast: (state) => {
      state.showSuccessToast = !state.showSuccessToast;
    },
    setToggle: (state, action) => {
      state.toggle = action.payload;
    },
    setTags: (state, action) => {
      state.ownerAccountAvailabletags = action.payload;
    },
    setOwnerAllAccStatementLoading: (state, action) => {
      state.ownerAllAccStatementLoading = action.payload;
    },
    setOwnerAllAccItemisedLoading: (state, action) => {
      state.ownerAllAccItemisedLoading = action.payload;
    },

    resetpage: (state) => {
      state.storedPage = 1;
    },
    resetToggle: (state) => {
      state.toggle = false;
    },
    setStoredPage: (state, action) => {
      state.storedPage = action.payload;
    },
    resetOwnerBalance: (state) => {
      state.createTransactionBankRefreshError = null;
      state.createTransactionBankRefreshData = null;
    },
    resetLoading: (state) => {
      state.ownerAccBalanceLoading = false;
    },
    resetTokenExpire: (state) => {
      state.tokenExpire = false;
    },
    resetStatementData: (state) => {
      state.ownerAccStatementData = null;
      state.ownerAllAccStatementData = null;
    },
    resetItemisedData: (state) => {
      state.ownerAllAccItemisedData = null;
    },
    setAvailabelLabels: (state, action) => {
      state.ownerAccountAvailableLabels = action.payload;
    },
    updateStatementData: (state, action) => {
      let data = state.ownerAllAccStatementData?.statement?.map((statement) => {
        if (
          statement?.account_statement_entry_id ===
          action?.payload?.account_statement_entry_id
        ) {
          return {
            ...statement,
            description: action?.payload?.description,
          };
        }
        return statement;
      });
      state.ownerAllAccStatementData = {
        ...state.ownerAllAccStatementData,
        statement: data,
      };
    },
    updateItemizedStatementData: (state, action) => {
      let data = state.ownerAllAccItemisedData?.ecollection_callbacks?.map(
        (statement) => {
          if (
            statement?.ecollection_callback_id ===
            action?.payload?.ecollection_callback_id
          ) {
            return {
              ...statement,
              description: action?.payload?.description,
            };
          }
          return statement;
        },
      );
      state.ownerAllAccItemisedData = {
        ...state.ownerAllAccItemisedData,
        ecollection_callbacks: data,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(addNewLabelOwner.pending, (state, action) => {
      state.addOwnerLabelsLoading = true;
    });
    builder.addCase(addNewLabelOwner.fulfilled, (state, action) => {
      state.addOwnerLabelsLoading = false;
      state.addOwnerLabelsData = action.payload;
    });
    builder.addCase(addNewLabelOwner.rejected, (state, action) => {
      state.addOwnerLabelsLoading = false;
      state.addOwnerLabelsError = action.payload;
      state.addOwnerLabelsData = null;
    });
    builder.addCase(removeNewLabelOwner.pending, (state, action) => {
      state.removeOwnerLabelsLoading = true;
    });
    builder.addCase(removeNewLabelOwner.fulfilled, (state, action) => {
      state.removeOwnerLabelsLoading = false;
      state.removeOwnerLabelsData = action.payload;
    });
    builder.addCase(removeNewLabelOwner.rejected, (state, action) => {
      state.removeOwnerLabelsLoading = false;
      state.removeOwnerLabelsError = action.payload;
      state.removeOwnerLabelsData = null;
    });

    builder.addCase(addOwnerAccTags.pending, (state, action) => {
      state.tokenExpire = false;
      state.addOwnerAccTagsLoading = true;
    });
    builder.addCase(addOwnerAccTags.fulfilled, (state, action) => {
      state.tokenExpire = false;
      state.addOwnerAccTagsLoading = false;
      state.addOwnerAccTagsData = action.payload;
    });
    builder.addCase(addOwnerAccTags.rejected, (state, action) => {
      if (action?.payload?.response?.data?.errors?.token_expired) {
        state.tokenExpire = true;
      }
      state.addOwnerAccTagsData = null;
      state.addOwnerAccTagsError = action.payload;
      state.addOwnerAccTagsLoading = true;
    });

    builder.addCase(uploadStatement.pending, (state) => {
      state.uploadStatementLoading = true;
    });
    builder.addCase(uploadStatement.fulfilled, (state, action) => {
      state.uploadStatementLoading = false;
      state.uploadStatementData = action.payload;
    });
    builder.addCase(uploadStatement.rejected, (state, action) => {
      state.uploadStatementLoading = false;
      state.uploadStatementError = action.payload;
    });

    builder.addCase(uploadTransactionStatement.pending, (state) => {
      state.uploadTransactionStatementLoading = true;
    });
    builder.addCase(uploadTransactionStatement.fulfilled, (state, action) => {
      state.uploadTransactionStatementLoading = false;
      state.uploadTransactionStatementData = action.payload;
    });
    builder.addCase(uploadTransactionStatement.rejected, (state, action) => {
      state.uploadTransactionStatementLoading = false;
      state.uploadTransactionStatementError = action.payload;
    });
    builder.addCase(removeOwnerAccTags.pending, (state, action) => {
      state.tokenExpire = false;
      state.removeOwnerAccTagsLoading = true;
    });
    builder.addCase(removeOwnerAccTags.fulfilled, (state, action) => {
      state.tokenExpire = false;
      state.removeOwnerAccTagsLoading = false;
      state.removeOwnerAccTagsData = action.payload;
    });
    builder.addCase(removeOwnerAccTags.rejected, (state, action) => {
      if (action?.payload?.response?.data?.errors?.token_expired) {
        state.tokenExpire = true;
      }
      state.removeOwnerAccTagsData = null;
      state.removeOwnerAccTagsError = action.payload;
      state.removeOwnerAccTagsLoading = true;
    });
    builder.addCase(ownerDashboard.pending, (state, action) => {
      if (action?.payload?.summary?.available_labels) {
        state.ownerAccountAvailableLabels = [];
      }
      if (action?.payload?.summary?.available_tags) {
        state.ownerAccountAvailabletags = [];
      }
      state.ownerDashboardAccLoading = true;
    });
    builder.addCase(ownerDashboard.fulfilled, (state, action) => {
      state.ownerAccountAvailabletags =
        action?.payload?.summary?.available_tags;
      if (action?.payload?.summary?.available_tags) {
        sessionStorage.setItem(
          "AvailableTags",
          JSON.stringify(action?.payload?.summary?.available_tags || []),
        );
      }
      state.ownerAccountAvailableLabels =
        action?.payload?.summary?.available_labels;
      if (action?.payload?.summary?.available_labels) {
        sessionStorage.setItem(
          "AvailableLabelsOwner",
          JSON.stringify(action?.payload?.summary?.available_labels || []),
        );
      }

      state.ownerDashboardAccLoading = false;
      state.ownerDashboardAccData = action.payload;
    });
    builder.addCase(ownerDashboard.rejected, (state, action) => {
      if (action?.payload?.summary?.available_tags) {
        state.ownerAccountAvailabletags = [];
      }
      if (action?.payload?.summary?.available_labels) {
        state.ownerAccountAvailableLabels = [];
      }
      state.ownerDashboardAccError = true;
      state.ownerDashboardAccData = null;
    });
    builder.addCase(ownerViewAllAcc.pending, (state, action) => {
      if (action?.payload?.summary?.available_tags) {
        state.ownerAccountAvailabletags = [];
      }
      if (action?.payload?.summary?.available_labels) {
        state.ownerAccountAvailableLabels = [];
      }
      state.tokenExpire = false;
      state.ownerViewAllAccError = null;
      state.ownerViewAllAccErrorData = null;
      state.ownerViewAllAccLoading = true;
    });
    builder.addCase(ownerViewAllAcc.fulfilled, (state, action) => {
      state.ownerAccountAvailabletags =
        action?.payload?.summary?.available_tags;
      if (action?.payload?.summary?.available_tags) {
        sessionStorage.setItem(
          "AvailableTags",
          JSON.stringify(action?.payload?.summary?.available_tags || []),
        );
      }
      state.ownerAccountAvailableLabels =
        action?.payload?.summary?.available_labels;
      if (action?.payload?.summary?.available_labels) {
        sessionStorage.setItem(
          "AvailableLabelsOwner",
          JSON.stringify(action?.payload?.summary?.available_labels || []),
        );
      }
      state.tokenExpire = false;
      state.ownerViewAllAccLoading = false;
      state.ownerViewAllAccData = action.payload;
      state.ownerViewAllAccError = false;
      state.ownerViewAllAccErrorData = null;
    });
    builder.addCase(ownerViewAllAcc.rejected, (state, action) => {
      if (action?.payload?.summary?.available_tags) {
        state.ownerAccountAvailabletags = [];
      }
      if (action?.payload?.summary?.available_labels) {
        state.ownerAccountAvailableLabels = [];
      }
      if (action?.payload?.response?.data?.errors?.token_expired) {
        state.tokenExpire = true;
      }
      state.ownerViewAllAccError = true;
      state.ownerViewAllAccData = null;
      state.ownerViewAllAccErrorData = action.payload;
    });
    builder.addCase(ownerListViewAllAcc.pending, (state, action) => {
      if (action?.payload?.summary?.available_tags) {
        state.ownerAccountAvailabletags = [];
      }
      if (action?.payload?.summary?.available_labels) {
        state.ownerAccountAvailableLabels = [];
      }
      state.tokenExpire = false;
      state.ownerViewAllListAccError = null;
      state.ownerViewAllListAccErrorData = null;
      state.ownerViewAllListAccLoading = true;
    });
    builder.addCase(ownerListViewAllAcc.fulfilled, (state, action) => {
      state.ownerAccountAvailabletags =
        action?.payload?.summary?.available_tags;
      if (action?.payload?.summary?.available_tags) {
        sessionStorage.setItem(
          "AvailableTags",
          JSON.stringify(action?.payload?.summary?.available_tags || []),
        );
      }
      state.ownerAccountAvailableLabels =
        action?.payload?.summary?.available_labels;
      if (action?.payload?.summary?.available_labels) {
        sessionStorage.setItem(
          "AvailableLabelsOwner",
          JSON.stringify(action?.payload?.summary?.available_labels || []),
        );
      }
      state.tokenExpire = false;
      state.ownerViewAllListAccLoading = false;
      state.ownerViewAllListAccData = action.payload;
      state.ownerViewAllListAccError = false;
      state.ownerViewAllListAccErrorData = null;
    });
    builder.addCase(ownerListViewAllAcc.rejected, (state, action) => {
      if (action?.payload?.summary?.available_tags) {
        state.ownerAccountAvailabletags = [];
      }
      if (action?.payload?.summary?.available_labels) {
        state.ownerAccountAvailableLabels = [];
      }
      if (action?.payload?.response?.data?.errors?.token_expired) {
        state.tokenExpire = true;
      }
      state.ownerViewAllListAccError = true;
      state.ownerViewAllListAccData = null;
      state.ownerViewAllListAccErrorData = action.payload;
    });
    builder.addCase(ownerAccDetail.pending, (state, action) => {
      state.ownerAccDetailLoading = true;
    });
    builder.addCase(ownerAccDetail.fulfilled, (state, action) => {
      state.ownerAccDetailLoading = false;
      state.ownerAccDetailData = action.payload;
      state.ownerAccDetailError = null;
    });
    builder.addCase(ownerAccDetail.rejected, (state, action) => {
      state.ownerAccDetailError = action.payload;
      state.ownerAccDetailData = null;
      state.ownerAccDetailLoading = false;
    });
    builder.addCase(ownerAccAddFavourite.pending, (state, action) => {
      state.ownerAccAddFavouriteLoading = true;
    });
    builder.addCase(ownerAccAddFavourite.fulfilled, (state, action) => {
      state.ownerAccAddFavouriteError = null;
      state.ownerAccAddFavouriteDetail = action?.payload;
      state.ownerAccAddFavouriteLoading = false;
    });
    builder.addCase(ownerAccAddFavourite.rejected, (state, action) => {
      state.ownerAccAddFavouriteError = action.payload;
      state.ownerAccAddFavouriteDetail = null;
      state.ownerAccAddFavouriteLoading = false;
    });
    builder.addCase(ownerAccRemoveFavourite.pending, (state, action) => {
      state.ownerAccRemoveFavouriteLoading = true;
    });
    builder.addCase(ownerAccRemoveFavourite.fulfilled, (state, action) => {
      state.ownerAccRemoveFavouriteError = null;
      state.ownerAccRemoveFavouriteDetail = action?.payload;
      state.ownerAccRemoveFavouriteLoading = false;
    });
    builder.addCase(ownerAccRemoveFavourite.rejected, (state, action) => {
      state.ownerAccRemoveFavouriteError = action.payload;
      state.ownerAccRemoveFavouriteDetail = null;
      state.ownerAccRemoveFavouriteLoading = false;
    });
    builder.addCase(getOwnerAccBalance.pending, (state, action) => {
      state.ownerAccBalanceLoading = true;
    });
    builder.addCase(getOwnerAccBalance.fulfilled, (state, action) => {
      state.ownerAccBalanceLoading = false;
      state.showSuccessToast = true;
      state.ownerAccBalanceData = action.payload;
    });
    builder.addCase(getOwnerAccBalance.rejected, (state, action) => {
      if (action?.payload?.response?.data?.errors?.token_expired) {
        state.tokenExpire = true;
      }
      state.ownerAccBalanceLoading = false;
      state.ownerAccBalanceError = true;
      state.showSuccessToast = false;
      state.ownerAccBalanceData = null;
    });
    builder.addCase(getCreateTransactionBalance.pending, (state, action) => {
      state.createTransactionBankRefreshLoading = true;
    });
    builder.addCase(getCreateTransactionBalance.fulfilled, (state, action) => {
      state.createTransactionBankRefreshLoading = false;
      state.createTransactionBankRefreshData = action.payload;
    });
    builder.addCase(getCreateTransactionBalance.rejected, (state, action) => {
      state.createTransactionBankRefreshLoading = false;
      state.createTransactionBankRefreshError = action.payload;
      state.createTransactionBankRefreshData = null;
    });
    builder.addCase(refreshAllOwnerAccBalance.pending, (state, action) => {
      state.ownerAllAccBalanceLoading = true;
    });
    builder.addCase(refreshAllOwnerAccBalance.fulfilled, (state, action) => {
      state.ownerAllAccBalanceLoading = false;
    });
    builder.addCase(refreshAllOwnerAccBalance.rejected, (state, action) => {
      if (action?.payload?.response?.data?.errors?.token_expired) {
        state.tokenExpire = true;
      }
      state.ownerAllAccBalanceError = true;
      state.ownerAllAccBalanceLoading = false;
    });
    builder.addCase(getOwnerAccStatement.pending, (state, action) => {
      state.ownerAccStatementLoading = true;
    });
    builder.addCase(getOwnerAccStatement.fulfilled, (state, action) => {
      state.ownerAccStatementLoading = false;
      state.ownerAccStatementError = false;
      state.ownerAccStatementData = action.payload;
    });
    builder.addCase(getOwnerAccStatement.rejected, (state, action) => {
      if (action?.payload?.response?.data?.errors?.token_expired) {
        state.tokenExpire = true;
      }
      state.ownerAccStatementData = null;
      state.ownerAccStatementError = true;
      state.ownerAccStatementLoading = false;
    });
    builder.addCase(addStatementDescription.pending, (state, action) => {
      state.ownerAllAccAddDescriptionLoading = true;
    });
    builder.addCase(addStatementDescription.fulfilled, (state, action) => {
      toast.dismiss();
      CommonToast({
        text: "Description updated successfully.",
        icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
        variant: "var(--success)",
        buttonNeeded: false,
      });
      state.ownerAllAccAddDescriptionLoading = false;
      state.ownerAllAccAddDescriptionError = false;
      state.ownerAllAccAddDescriptionData = action.payload;
    });
    builder.addCase(addStatementDescription.rejected, (state, action) => {
      if (action?.payload?.response?.data?.errors?.token_expired) {
        state.tokenExpire = true;
      }
      state.ownerAllAccAddDescriptionData = null;
      state.ownerAllAccAddDescriptionError = true;
      state.ownerAllAccAddDescriptionLoading = false;
    });
    builder.addCase(
      addItemizedStatementDescription.pending,
      (state, action) => {
        state.ownerItemizedAddDescriptionLoading = true;
      },
    );
    builder.addCase(
      addItemizedStatementDescription.fulfilled,
      (state, action) => {
        toast.dismiss();
        CommonToast({
          text: "Description updated successfully.",
          icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
          variant: "var(--success)",
          buttonNeeded: false,
        });
        state.ownerItemizedAddDescriptionLoading = false;
        state.ownerItemizedAddDescriptionError = false;
        state.ownerItemizedAddDescriptionData = action.payload;
      },
    );
    builder.addCase(
      addItemizedStatementDescription.rejected,
      (state, action) => {
        if (action?.payload?.response?.data?.errors?.token_expired) {
          state.tokenExpire = true;
        }
        state.ownerItemizedAddDescriptionData = null;
        state.ownerItemizedAddDescriptionError = true;
        state.ownerItemizedAddDescriptionLoading = false;
      },
    );
    builder.addCase(getAllOwnerAccStatement.pending, (state, action) => {
      state.ownerAllAccStatementLoading = true;
    });
    builder.addCase(getAllOwnerAccStatement.fulfilled, (state, action) => {
      state.ownerAllAccStatementLoading = false;
      state.ownerAllAccStatementError = false;
      state.ownerAllAccStatementData = action.payload;
    });
    builder.addCase(getAllOwnerAccStatement.rejected, (state, action) => {
      if (action?.payload?.response?.data?.errors?.token_expired) {
        state.tokenExpire = true;
      }
      state.ownerAllAccStatementData = null;
      state.ownerAllAccStatementError = true;
      state.ownerAllAccStatementLoading = false;
    });
    builder.addCase(getAllOwnerItemisizedReport.pending, (state, action) => {
      CommonToast({
        text: "Fetching live statement",
        icon: "https://q2pay.in/new_assets/gifs/inputloader_white.gif",
        variant: "var(--processing)",
        buttonNeeded: false,
      });

      state.ownerAllAccItemisedLoading = true;
    });
    builder.addCase(getAllOwnerItemisizedReport.fulfilled, (state, action) => {
      toast.dismiss();
      CommonToast({
        text: "Live statement fetched successfully.",
        icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
        variant: "var(--success)",
        buttonNeeded: false,
      });
      state.ownerAllAccItemisedLoading = false;
      state.ownerAllAccItemisedError = false;
      state.ownerAllAccItemisedData = action.payload;
    });
    builder.addCase(getAllOwnerItemisizedReport.rejected, (state, action) => {
      if (action?.payload?.response?.data?.errors?.token_expired) {
        state.tokenExpire = true;
      }
      state.ownerAllAccItemisedData = null;
      state.ownerAllAccItemisedError = true;
      state.ownerAllAccItemisedLoading = false;
    });

    builder.addCase(downloadOwnerStatement.pending, (state, action) => {
      state.ownerAccStatementDownloadLoading = true;
    });
    builder.addCase(downloadOwnerStatement.fulfilled, (state, action) => {
      state.ownerAccStatementDownloadLoading = false;
      state.ownerAccStatementDownloadStatus = action.payload;
    });

    builder.addCase(downloadOwnerStatement.rejected, (state, action) => {
      state.ownerAccStatementDownloadLoading = false;
      state.ownerAccStatementDownloadError = action.payload;
    });
    builder.addCase(downloadSampleFile.pending, (state, action) => {
      state.downloadSampleFileLoading = true;
    });
    builder.addCase(downloadSampleFile.fulfilled, (state, action) => {
      state.downloadSampleFileLoading = false;
      state.downloadSampleFileStatus = action.payload;
    });

    builder.addCase(downloadSampleFile.rejected, (state, action) => {
      state.downloadSampleFileLoading = false;
      state.downloadSampleFileError = action.payload;
    });

    builder.addCase(getOwnerAccountIFSCDetails.pending, (state, action) => {
      state.ownerAccIfscLoading = true;
      state.ownerAccIfscError = false;
    });
    builder.addCase(getOwnerAccountIFSCDetails.fulfilled, (state, action) => {
      state.ownerAccIfscLoading = false;
      state.ownerAccIfscData = action.payload;
    });
    builder.addCase(getOwnerAccountIFSCDetails.rejected, (state, action) => {
      state.ownerAccIfscError = true;
      state.ownerAccIfscLoading = false;
    });
    builder.addCase(getOwnerAccStatitics.pending, (state, action) => {
      state.getOwnerAccStatiticsLoading = true;
    });
    builder.addCase(getOwnerAccStatitics.fulfilled, (state, action) => {
      state.getOwnerAccStatiticsLoading = false;
      state.getOwnerAccStatiticsData = action.payload;
    });
    builder.addCase(getOwnerAccStatitics.rejected, (state, action) => {
      state.getOwnerAccStatiticsError = true;
      state.getOwnerAccStatiticsLoading = false;
    });
    builder.addCase(getOwnerAccWeekStatitics.pending, (state, action) => {
      state.getOwnerAccWeekStatiticsLoading = true;
    });
    builder.addCase(getOwnerAccWeekStatitics.fulfilled, (state, action) => {
      state.getOwnerAccWeekStatiticsLoading = false;
      state.getOwnerAccWeekStatiticsData = action.payload;
    });
    builder.addCase(getOwnerAccWeekStatitics.rejected, (state, action) => {
      state.getOwnerAccWeekStatiticsError = true;
      state.getOwnerAccWeekStatiticsLoading = false;
    });
  },
});

export const {
  setWindowWidth,
  setshowsuccestoast,
  setToggle,
  resetpage,
  setStoredPage,
  resetOwnerBalance,
  resetLoading,
  resetTokenExpire,
  resetToggle,
  setTags,
  resetStatementData,
  setOwnerAllAccStatementLoading,
  uploadStatementLoading,
  uploadTransactionStatementError,
  resetLabelOwnerLoading,
  resetItemisedData,
  setOwnerAllAccItemisedLoading,
  updateStatementData,
  updateItemizedStatementData,
  // uploadTransactionStatementLoading,
} = ownerAllVerification.actions;

export default ownerAllVerification.reducer;
